<div>
    <app-app-list [apps]="appList"></app-app-list>
<div>